import React, { useState, useMemo, useCallback, useContext, useEffect } from "react";
import { Button, Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { useQuery, useQueryClient } from "react-query";
import {  Skeleton, Spin } from "antd";
import HistoryContext from "../../../../common/HistoryContext";
import { getBusinessVolumeTransactions, getManagePayIn, getTopTransactions, getTransctionByBusinessId } from "../services/transApi.js";
import '../utils/style.css';
import filter from "../../../../assets/images/cuida_filter-outline.png";
import trier from "../../../../assets/images/mdi_sort.png";
import { getAllMerchent, getBusinessMarchandById } from "../../merchant/services/merchentApi.js";
import DetailTransactionModal from "../component/DetailTransactionModal.js";
import FiltrerTransactionModal from "../component/FiltrerTransactionModal .js";
import TrierTransactionModal from "../component/TrierTransactionModal.js";
import TableContainerMin from "../../../../common/TableContainerMin.js";
import { Select } from 'antd';
import { FormatCurrency } from "../../../../common/format/formatCurrency.js";
import rentable from "../../../../assets/images/rentable.png";
import semaine from "../../../../assets/images/semaine.png";
import PaginationCustom from "../../merchant/component/paginationCustom.js";
import inactif from "../../../../assets/images/Vector.png";
const AllTransactions = () => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [modalState, setModalState] = useState({ type: null, data: null });
  const [loadingTop, setLoadingTop] = useState(false);
  const [loadingInactif, setLoadingInactif] = useState(false);
  const [topBusinessVolumeTransactions , setTopBusinessVolumeTransactions ] = useState([]);
  const [topTransactions, setTopTransactions] = useState([]);
   const [filterValues, setFilterValues] = useState(null);
   const [newPage, setNewPage] = useState(1);
   const size = 4; 
   const [totalPages, setTotalPages] = useState(0);
    const { isLoading, isError, error, data: merchants } = useQuery(
  "merchants",
  getAllMerchent
);
useEffect(() => {
  const fetchTopBusinessVolumeTransactions = async () => {
    try {
      setLoadingTop(true);
      const res = await getBusinessVolumeTransactions ();
      setTopBusinessVolumeTransactions (res?.data ||  []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingTop(false);
    }
  };
  fetchTopBusinessVolumeTransactions();
}, []);
useEffect(() => {
  const fetchTopTransactions = async () => {
    try {
      setLoadingTop(true);

      const res = await getTopTransactions();

      const data = res?.data || [];

      const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;

     setTopTransactions(
  data.sort((a, b) => b.amount - a.amount)
);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingTop(false);
    }
  };

  fetchTopTransactions();
}, []);
const paginationTopTransactions = useMemo(() => {
  const start = (newPage - 1) * size;
  const end = start + size;
  return topTransactions.slice(start, end);
}, [topTransactions, newPage]);
  const [isDeleting, setIsDeleting] = useState(false);
  const currentuser = JSON.parse(sessionStorage.getItem('authUser'));
  const merchandId = currentuser?.user?.id;
  const [selectedMarchand, setSelectedMarchand] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState("");
  const { isLoadingM, isErrorM, errorM, data: merchents } = useQuery("merchents", getAllMerchent);
  const [page, setPage] = useState(1);
  const [inactifMerchants, setInactifMerchants] = useState([]);
  const pagination = useMemo(() => ({
    pageIndex: page - 1,
    canPreviousPage: page > 1,
    canNextPage: page < totalPages,
    gotoPage: (i) => setPage(i + 1),
    previousPage: () => setPage((p) => Math.max(p - 1, 1)),
    nextPage: () => setPage((p) => Math.min(p + 1, totalPages)),
  }), [page, totalPages]);
  //fonctions pour recuperer toutes les transactions
  const {
  data: allTransactionsResponse,
  isLoading: isLoadingAllTransactions,
} = useQuery(
  "allTransactions",
  getManagePayIn
);
//pour recuperer toutes les transactions
const allTransactions = Array.isArray(allTransactionsResponse?.data)
  ? allTransactionsResponse.data
  : [];
  const {
  data: transactionsByBusinessResponse,
  isLoading: isLoadingTransactions,
  isError: isErrorTransactions,
  error: errorTransactions,
} = useQuery(
  ["transactionsByBusiness", selectedBusiness],
  () => getTransctionByBusinessId(selectedBusiness),
  {
    enabled: !!selectedBusiness,
  }
);
const transactionsByBusiness = Array.isArray(transactionsByBusinessResponse?.data)
  ? transactionsByBusinessResponse.data
  : [];
const {
  data: developersByMerchant,
  isLoading: isLoadingByMerchant,
  isError: isErrorByMerchant,
  error: errorByMerchant,
} = useQuery(
  ["developersByMerchant", selectedMarchand],
  () => getBusinessMarchandById(selectedMarchand),
  {
    enabled: !!selectedMarchand, // seulement si un marchand est sélectionné
  }
);
const developers = selectedMarchand ? developersByMerchant : '';
  const tabs = ['Tous', 'Actives', 'En cours', 'Désactivés', 'Rejetés'];
  const [activeTab, setActiveTab] = useState('Tous');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
const [sortOrder, setSortOrder] = useState("desc");
const [searchText, setSearchText] = useState("");
const filteredTransactions = useMemo(() => {
  let result = [...transactionsByBusiness];

  if (searchText) {
    result = result.filter((transaction) =>
      Object.values(transaction).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }

  if (filterValues) {
    if (filterValues.status) {
      result = result.filter((t) => t.status === filterValues.status);
    } 
    if (filterValues.paymentMethod) {
      result = result.filter((t) => t.payment_method === filterValues.paymentMethod);
    }

   if (filterValues.createdAtFrom) {
    const from = new Date(filterValues.createdAtFrom).setHours(0, 0, 0, 0);

    result = result.filter((t) => {
      const txDate = new Date(t.createdAt).setHours(0, 0, 0, 0);
      return txDate >= from;
    });
  }

if (filterValues.createdAtTo) {
  const to = new Date(filterValues.createdAtTo).setHours(23, 59, 59, 999);

  result = result.filter((t) => {
    const txDate = new Date(t.createdAt).getTime();
    return txDate <= to;
  });
}
    if (filterValues.minAmount != null) {
      result = result.filter((t) => t.amount >= filterValues.minAmount);
    }
    if (filterValues.maxAmount != null) {
      result = result.filter((t) => t.amount <= filterValues.maxAmount);
    }
  }
  if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
          } else {
            result.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          }
  return result;
}, [searchText, transactionsByBusiness, filterValues]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };
  const handleDetail = (transaction) => {
    openModal("detail", transaction);
  };
   const handleApplyFilters = (filters) => {
  setFilterValues(filters);
};
  const columns = useMemo(() => [
    { Header: "ID Transactions", accessor: "transactionReference", filterable: false },
     {
        Header: "Date transaction",
        accessor: "createdAt",
        Cell: ({ value }) =>
          value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
    filterable: false,
    },
    {
    Header: "Statut",
    accessor: "status",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", // par défaut orange pâle
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === "SUCCESS") {
        label = " Réussie";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";
      } else if (value ==="REJECTED") {
        label = "Echouée";
         icon = "✓"; 
        style.backgroundColor = "#FFF0F0"; 
        style.color = "#D41C1C";           
      }
      else if (value ==="PENDING") {
        label = "En cours";
         icon = "⏳"; 
        style.backgroundColor = "#FFFBE6"; 
        style.color = "#AD8B00"; 
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    },
     {
      Header: "Opérateur",
      accessor: "paymentMethodName",
      Cell: ({ value }) => (
        <span>
          {value} 
        </span>
      ),
      filterable: false,
    },
    {
      Header: "Montant",
      accessor: "amount",
      Cell: ({ value }) => (
        <span style={{ fontWeight: 600,fontSize:"13px",color:"#070707",fontDFamily:"poppins" }}>
          {value} XOF
        </span>
      ),
      filterable: false,
    },
    {
      Header: "Actions",
      Cell: ({ row }) => {
        return (
           <button className="detail" onClick={() => openModal("transaction-detail", row.original)}>Détails</button>
        );
      },
      filterable: false,
    },
  ], [ handleDetail ]);

  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab === tab ? 'active-tab' : 'btn-light'}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
const paymentMethods = useMemo(() => {
  if (!filteredTransactions) return [];
  const methodsSet = new Set(
    filteredTransactions.map((t) => t.paymentMethodName)
  );
  return Array.from(methodsSet);
}, [filteredTransactions]);
//soit tous les transactions ou transaction du'in business avec le larchand
const displayedTransactions = selectedBusiness
  ? filteredTransactions
  : allTransactions;
const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Vérifie dès le chargement
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [loadingStats, setLoadingStats] = useState(false);
  const [statAccount, setStatAccount] = useState([]);
  const titleText = selectedBusiness
  ? "Transactions du marchand et son business sélectionné"
  : "Liste complète de tous les transactions de la plateforme";
   const HeaderTable = () => 
    <div className="d-flex flex-column align-items-start gap-3 w-100 mb-3">
      <div className='title-page mb-2'>
        Transactions
        <span className="lenght">
                    {isLoadingTransactions ? (
                      <Spin size="small" />
                    ) : !displayedTransactions?.length ? (
                      "0"
                    ) : (
                      displayedTransactions?.length
                    )}
              </span>
      </div>
      <div className="d-flex flex-row align-items-start gap-3 w-100 mb-2">
        <Select className='mb-3'
                showSearch
                allowClear
                placeholder="Tous les marchands"
                value={selectedMarchand}
                onChange={(value) => setSelectedMarchand(value || null)}
                style={{ width: 250 }}
                optionFilterProp="children"
              >
                <Select.Option value="">
                  Tous les marchands
                </Select.Option>
        
                {Array.isArray(merchents) &&
                  merchents.map((marchand) => (
                    <Select.Option key={marchand.id} value={marchand.id}>
                      {marchand.firstName} {marchand.lastName}
                    </Select.Option>
                  ))}
              </Select>
              <Select className='mb-3'
                      showSearch
                      allowClear
                      placeholder="Tous les business"
                      value={selectedBusiness}
                      onChange={(value) => setSelectedBusiness(value || null)}
                      style={{ width: 250 }}
                       disabled={!selectedMarchand}
                      optionFilterProp="children"
                    >
                      <Select.Option value="">
                        Tous les business
                      </Select.Option>
              
                      {Array.isArray(developersByMerchant) &&
                        developersByMerchant.map((dev) => (
                          <Select.Option key={dev.id} value={dev.id}>
                           {dev.businessName}
                          </Select.Option>
                        ))}
                    </Select>
                  </div>  
              </div>    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <HeaderTable />
            <Card className="mb-3"
                    style={{
                      padding: "12px",
                      border: "1px solid #0000001A",
                      borderRadius: "12px",  
                      backgroundColor: "#FFFFFF"
                      }}
                  >
                     <div className="row">
                    
                    <div className="col-md-4">
                      <Card className="card-business">
                        <div className="d-flex justify-content-between align-items-center naming">
                          <span>Montant net encaissé</span>
                        </div>
                  
                        <div className="d-flex flex-column gap-1">
                            {loadingStats?(
                              <Spin size="small"/>
                          ):(
                                <div className="CAD">{FormatCurrency(statAccount?.availableBalance||0)}</div>
                          )}
                        </div>
                      </Card>
                    </div>
                  
                    <div className="col-md-4">
                      <Card className="card-business">
                        <div className="d-flex justify-content-between align-items-center naming">
                          <span>Valeur moyenne d’une transaction</span>
                        </div>
                  
                        <div className="d-flex flex-column gap-1">
                          {loadingStats?(
                              <Spin size="small"/>
                          ):(
                          <div className="CA">{FormatCurrency(statAccount?.balance||0)}</div>
                          )
                      }
                        </div>
                      </Card>
                    </div>
                  
                    <div className="col-md-4">
                      <Card className="card-business">
                        <div className="d-flex justify-content-between align-items-center naming">
                          <span>Taux de succès</span>
                        </div>
                  
                        <div className="d-flex flex-column gap-1">
                           {loadingStats?(
                              <Spin size="small"/>
                          ):(
                          <div className="CA">{FormatCurrency(statAccount?.totalTransferAmount||0)}</div>
                          )
                          }
                        </div>
                      </Card>
                    </div>
                  </div>
                  </Card> 
                   <div style={{ backgroundColor: '#FBFBFB', padding: '10px',width: '100%',
    minHeight: '180px', 
    boxSizing: 'border-box'}} className="mb-3">
  <Row className="g-3">
  <Col xs={12} md={6} className="">
    <Card
      className="card-animate w-100 h-100"
      style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
    <CardBody className="d-flex flex-column">
  <div className="d-flex justify-content-between align-items-center">
    <div className="title-top">
      Top business par volume de transactions
    </div>

    <div style={{ fontWeight:'400', fontSize:"15px", fontFamily:"Poppins", color:"#000000CC" }}>
      <img src={rentable} alt="Filtrer" width={20} />
    </div>
  </div>
  {loadingTop ? (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Spin/>
    </div>
  ) : (
    topBusinessVolumeTransactions.map((transaction , index) => (
      <div
        key={transaction.id || index}
        className="d-flex justify-content-between align-items-center mt-2">
        <div className="d-flex align-items-start gap-2">
          <span className="rank-circle">{index + 1}</span>
          <div className="d-flex flex-column">
            <span className="title-name-merchend">
              {transaction.merchantAccountName}
            </span>
            <span className="title-number-business">
             business {transaction.developerAccountName || 0}
            </span>
          </div>
        </div>
        <div className="revenu-merchend">
          {FormatCurrency(transaction.totalAmount || 0)}
        </div>
      </div>
    ))
  )}
</CardBody>
</Card>
  </Col>
  <Col xs={12} md={6} className="d-flex flex-column gap-3">
    <Card
      className="card-animate w-100"
       style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
<CardBody className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div  className="title-top">
           Top transactions les plus élevées (7 derniers jours)
          </div>
          <div style={{ fontWeight:'400',fontSize:"15px",fontFamily:"Poppins",color:"#000000CC" }}>
             <img src={semaine} alt="Filtrer" width={20} />
          </div>
        </div>
         {loadingTop ? (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Spin/>
    </div>
  ) :(
     paginationTopTransactions.map((topTransactions) => (
    <div
    key={topTransactions.id}
    className="d-flex justify-content-between align-items-center mt-2"
  >
    <div className="d-flex align-items-start gap-2">
   <div className="avatar-circle">
      {topTransactions.merchantAccountName
        ?.split(" ")
        .map((name) => name[0])
        .slice(0, 2)
        .join("")
        .toUpperCase()}
    </div>
      <div className="d-flex flex-column">
        <span className="title-name-merchend">
          {topTransactions.merchantAccountName}
        </span>
      </div>
    </div>
    {/* RIGHT */}
    <div className="revenu-merchend">
      {FormatCurrency(topTransactions.amount ||0 )}
    </div>
  </div>
))
  )}
  <PaginationCustom
    pageIndex={newPage - 1}
    totalPages={Math.ceil(topTransactions.length / size)}
    canPreviousPage={newPage > 1}
    canNextPage={newPage < Math.ceil(topTransactions.length / size)}
    previousPage={() => setNewPage((p) => Math.max(p - 1, 1))}
    nextPage={() =>
      setNewPage((p) =>
        Math.min(p + 1, Math.ceil(topTransactions.length / size))
      )
    }
    gotoPage={(i) => setNewPage(i + 1)}
  />
</CardBody>
</Card>
    <Card
      className="card-animate w-100"
       style={{
         borderRadius: "10px",background:"#FFFFFF",border:'none',
      }}
    >
       <CardBody className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div  className="title-top">
          Répartition par moyen de paiement (%)
          </div>
          <div style={{ fontWeight:'400',fontSize:"15px",fontFamily:"Poppins",color:"#000000CC" }}>
             <img src={inactif} alt="Filtrer" width={20} />
          </div>
        </div>
         {loadingInactif ? (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Spin/>
    </div>
  ) : (
    inactifMerchants.map((merchand, index) => (
        <div key={merchand.id || index} className="d-flex justify-content-between align-items-center mt-2">
         <div className="d-flex align-items-start gap-2">
         <div className="avatar-circle-inactif">
          {merchand.merchantName
            ?.split(" ")
            .map((n) => n[0])
            .slice(0, 2)
            .join("")
            .toUpperCase()}
        </div>
          <div className="d-flex flex-column">
            <span className="title-name-merchend">
             {merchand.merchantName}
            </span>
            <span className="title-number-business">
              Dernière activité:{" "}
              {merchand.lastActivityDate
                ? new Date(merchand.lastActivityDate).toLocaleString("fr-FR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "-"}
              </span>
          </div>
        </div>
          <div className="title-number d-flex align-items-center gap-1">
          <span className="statut">{FormatCurrency(merchand.totalRevenue) ||0}</span>
        </div>
        </div>
    )))}
  <PaginationCustom
  pageIndex={pagination.pageIndex}
  totalPages={totalPages}
  canPreviousPage={pagination.canPreviousPage}
  canNextPage={pagination.canNextPage}
  previousPage={pagination.previousPage}
  nextPage={pagination.nextPage}
  gotoPage={pagination.gotoPage}
/>
</CardBody>
</Card>
</Col>
</Row>
</div>
<div className='title-page mb-2'>
    Transactions
   <div className="trans">{titleText}</div>
  </div>
          <div className="header-actions w-100 mb-2">
            <div className="col-6 p-0">
              <input
                type="text"
                placeholder="Rechercher une transaction..."
                className="form-control search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
           
            <Button className="filtrer" onClick={() => openModal("transaction-filtrer")}style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src={filter} alt="Filtrer" style={{ width: "24px", height: "24px" }} />
            Filtrer
          </Button>
          <Button onClick={() => openModal("transaction-trier")} className="filtrer" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img src={trier} alt="Filtrer" style={{ width: "24px", height: "24px" }} />
            Trier
          </Button>
          
        </div>
         <Row className="w-100 m-0">
          <Col className="w-100 p-0">
              <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
                <CardBody className="p-0 " >
                  <TableContainerMin
                    columns={columns}
                  data={displayedTransactions}
                    isGlobalSearch={false}
                    isGlobalFilter={false}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive w-100"
                   tableClass="table w-100 mb-0 no-column-borders"
                    theadClass="custom-thead "
                    SearchPlaceholder="Recherche..."
                    HeaderTable={HeaderTable}
                  />
                    
                    {isLoadingTransactions && selectedBusiness && (
                      <div className="text-center">Chargement des transactions... <Skeleton /></div>
                    )}

                    {selectedBusiness && !isLoadingTransactions && transactionsByBusiness?.length === 0 && (
                      <div className="text-center">Aucune transaction trouvée pour ce business.</div>
                    )}
                </CardBody>
              </Card>
            </Col>
          </Row>          
          {modalState.type === "transaction-detail" && (
              <DetailTransactionModal
                isOpen={modalState.type === "transaction-detail"}
                toggle={() => openModal("transaction-detail", modalState.data)}
                transaction={modalState.data}
              />
            )}
             {modalState.type === "transaction-filtrer" && (
              <FiltrerTransactionModal
                isOpen={modalState.type === "transaction-filtrer"}
                toggle={() => openModal("transaction-filtrer", modalState.data)}
                onApply={handleApplyFilters}
                 paymentMethods={paymentMethods}
              />
            )}
             {modalState.type === "transaction-trier" && (
            <TrierTransactionModal
              isOpen={modalState.type === "transaction-trier"}
              toggle={() => openModal("transaction-trier", modalState.data)}
              onApplySort={(order) => setSortOrder(order)}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );

}
export default AllTransactions;
